import React from 'react';
import { motion } from 'framer-motion';
import { homeServices } from '../data/services';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }
  }
};
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-783" data-mp="13w4ohpqr3fde">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-784" data-mp="13xxxhbou6bok">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-785" data-mp="z4cwdary51l5">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 tracking-tight" data-id="element-786" data-mp="u5s4bymulo7s">
            Everything you need to scale
          </h2>
          <p className="text-lg text-gray-600" data-id="element-787" data-mp="q6b018j5qx47">
            We provide an end-to-end growth ecosystem. From driving traffic to closing leads, we've got you covered.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-4" data-id="element-788" data-mp="g6sggt75tdco">
          {homeServices.map(service => <motion.article key={service.title} variants={cardVariants} className="flex h-full flex-col items-center rounded-xl border border-brand-red bg-white px-6 pb-8 pt-6 text-center" data-id="element-789" data-mp="2xdciktdjlaja">
              <img src={service.image} alt="" aria-hidden="true" loading="lazy" decoding="async" width={160} height={160} className="h-40 w-40 object-contain" data-id="element-790" data-mp="3u1saux81dy03" />
              <h3 className="mt-4 text-2xl font-semibold leading-tight text-brand-black" data-id="element-791" data-mp="3g2151jrobnx6">{service.title}</h3>
              <p className="mt-3 flex-1 text-base leading-relaxed text-gray-700" data-id="element-792" data-mp="3l3gnr56dpice">{service.description}</p>
              <a href={service.href} className="mt-8 inline-flex items-center justify-center rounded-md bg-brand-red px-6 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-793" data-mp="24pgq60v0a4sb">
                {service.cta}
              </a>
            </motion.article>)}
        </motion.div>
      </div>
    </section>;
}